// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import { sub } from 'date-fns/sub'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_DogLiabilityV1GetsafeDe = z.object({
  dogs: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string().min(1).optional(),
      breeds: z.array(z.object({ breed: z.string().min(1) })),
      breed_type: z.enum(['pedigree', 'crossbreed', 'unknown']),
      breed_class: z.preprocess((val) => {
        if (val === '' || val === undefined) {
          return undefined
        }
        return Number(val)
      }, z.number().int()),
    })
  ),
  born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(
      z.coerce
        .date()
        .min(sub(new Date(), { years: 120 }))
        .max(sub(new Date(), { years: 18 }))
    )
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  tariff_line: z.enum(['comfort', 'premium']),
  deductible_amount: z.coerce
    .string()
    .pipe(z.enum(['0', '150', '300']))
    .pipe(z.coerce.number()),
  sos_help_coverage: z.boolean(),
  number_of_claims_in_last_5y: z.coerce
    .string()
    .pipe(z.enum(['0', '1', '2']))
    .pipe(z.coerce.number())
    .optional(),
  cancelled_by_previous_insurer: z.coerce
    .string()
    .pipe(z.enum(['false']))
    .transform(() => false)
    .optional(),
  previous_insurance_in_last_5y: z.boolean(),
})

const Schema_DogLiabilityV1GetsafeDe = BaseSchema_DogLiabilityV1GetsafeDe.superRefine(
  (values, ctx) => {
    if (
      values['previous_insurance_in_last_5y'] !== undefined &&
      [true].includes(values['previous_insurance_in_last_5y'])
    ) {
      if (values['number_of_claims_in_last_5y'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'integer',
          received: 'undefined',
          message: 'Required',
          path: ['number_of_claims_in_last_5y'],
        })
      }
    }
  }
).superRefine((values, ctx) => {
  if (
    values['previous_insurance_in_last_5y'] !== undefined &&
    [true].includes(values['previous_insurance_in_last_5y'])
  ) {
    if (values['cancelled_by_previous_insurer'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'boolean',
        received: 'undefined',
        message: 'Required',
        path: ['cancelled_by_previous_insurer'],
      })
    }
  }
})

export default Schema_DogLiabilityV1GetsafeDe
